export default "__VITE_ASSET__CyroEp_R__"